export const theme = {
    fonts: {
        primaryFont: 'Montserrat',
        secondaryFont: 'Concert One'
    },
    fontSizes: {
        xxxs: '.5rem',
        xxs: '1rem',
        xs: '1.5rem',
        sm: '2rem',
        md: '2.5rem',
        lg: '3.5rem',
        xl: '5rem',
        xxl: '7rem'
    },
    fontWeights: {
        normal: 400,
        bold: 'bold'
    },
    colors: {
        primaryWhite: '#ffffff',
        primaryRed: '#FF4643',
        primaryBlue: '#0B2C3C',
        primaryBlack: '#000000',
        primaryGray: '#dfdfdf'
    },
    responsive: {
        xs: '480px',
        s: '620px',
        sm: '768px',
        md: '992px',
        lg: '1200px',
        xl: `1400px`,
    }
   };